import {
    AuthenticationDetails,
    CognitoUser,
    CognitoUserPool
} from 'amazon-cognito-identity-js';

const AWSConfig = {
    Credentials: {
        Username: 'file_upload',
        Password: 'Asd@123!@#'
    },
    AuthData: {
        UserPoolId: 'ap-south-1_PpUZ5NdVF',
        ClientId: '6gspd41pcsls2tvf0etc4le4qa',
        IdentityPollId: 'ap-south-1:daa25f67-a4a3-46d7-8767-cef9cc7dfc62'
    }
}

var AWSCognitoToken = null;

const AuthenticateCognito = () => {
    return new Promise((resolve, reject) => {
        const poolData = {
            UserPoolId: AWSConfig.AuthData.UserPoolId,           // Replace with your pool ID
            ClientId: AWSConfig.AuthData.ClientId        // Replace with your app client ID
        };

        const userPool = new CognitoUserPool(poolData);

        const authDetails = new AuthenticationDetails({
            Username: AWSConfig.Credentials.Username,                      // Replace with your username
            Password: AWSConfig.Credentials.Password                       // Replace with your password
        });

        const user = new CognitoUser({
            Username: AWSConfig.Credentials.Username,                     // Replace with your username
            Pool: userPool
        });

        user.authenticateUser(authDetails, {
            onSuccess: (resultData) => {
                user.getSession((err, session) => {
                    if (err) {
                        console.error('✕ Session error:', err);
                        reject(err);
                    }
                    const token = session.getIdToken().getJwtToken();
                    AWSCognitoToken = token;
                    console.log('✓ Authentication successful', session);
                    resolve(token);
                });
            },
            onFailure: (err) => {
                console.error('✕ Authentication failed:', err);
                reject(err);
            }
        });
    });
};

export { AuthenticateCognito, AWSConfig, AWSCognitoToken };
